import React, { useState } from 'react'
import "./Experience.css"
import "../../app/styles/styles.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import prevSvg from "../../app/assets/images/icons/previous.svg"
import nextSvg from "../../app/assets/images/icons/next.svg"
import birdWatchingImg from "../../app/assets/images/icons/birdwatching.png"
import forestWalkImg from "../../app/assets/images/icons/forest-walk.png"
import villageLifeImg from "../../app/assets/images/icons/village-life.png"
import natureTrailImg from "../../app/assets/images/icons/nature-trails.png"
import riveSideImg from "../../app/assets/images/icons/riveside.png"
import rularLearningImg from "../../app/assets/images/icons/rular-learning.png"
// import bridWatching from "../../app/assets/images/birdwatching-wildlife.webp"
import forestWalking from "../../app/assets/images/guided-forest.webp"
// import villageLife from "../../app/assets/images/village-life-experiences.webp"
// import natureTrail from "../../app/assets/images/cycling-nature-trails.webp"
// import riveSide from "../../app/assets/images/riverside.webp"
// import rularLearning from "../../app/assets/images/rural-learning.webp"

import bridWatching from "../../app/assets/images/birdwatching-wildlife.webp"
// import forestWalking from "../../app/assets/images/guided-forest.webp"
import villageLife from "../../app/assets/images/village-life-experiences.webp"
import natureTrail from "../../app/assets/images/cycling-nature-trails.webp"
import riveSide from "../../app/assets/images/riverside.webp"
import rularLearning from "../../app/assets/images/village-life.webp"
import { openBooking } from '../../app/utils/links';

function Experience() {
  const [season, setSeason] = useState('winter');

  const activities = [
    { id: 1, title: "Birdwatching & Wildlife Experiences Near Corbett", desc: "Explore one of India’s richest bird habitats", icon: birdWatchingImg, img: bridWatching },
    { id: 2, title: "Guided Forest Walks in Uttarakhand", desc: "Slow, immersive jungle exploration", icon: forestWalkImg, img: forestWalking },
    { id: 3, title: "Village Life Experiences Near Corbett National Park", desc: "Food, stories, and culture with local families", icon: villageLifeImg, img: villageLife },
    { id: 4, title: "Cycling & Nature Trails", desc: "Riverside and rural exploration at your pace", icon: natureTrailImg, img: natureTrail },
    { id: 5, title: "Riverside Body Surfing", desc: "A unique, seasonal forest-water experience", icon: riveSideImg, img: riveSide },
    { id: 6, title: "Sustainability & Rural Learning", desc: " Learn eco living through real practices", icon: rularLearningImg, img: rularLearning },
  ];

const tableData = {
  winter: [
    {
      act: "Birding",
      dur: "2 hrs",
      morning: "7:00 - 9:00 AM",
      evening: "3:00 - 5:00 PM",
    },
    {
      act: "Wildlife Safari",
      dur: "3 hrs",
      morning: "6:30 - 9:30 AM",
      evening: "2:00 - 5:00 PM",
    },
    {
      act: "Cycling (Mountain / Riverside)",
      dur: "1-2 hrs",
      morning: "9:00 - 11:00 AM",
      evening: "3:00 - 5:00 PM",
    },
    {
      act: "Guided Jungle Walk",
      dur: "2-3 hrs",
      morning: "10:00 AM - 12:00 PM",
      evening: "—",
    },
    {
      act: "Body Surfing (River Session)",
      dur: "1-2 hrs",
      morning: "10:00 AM - 12:00 PM",
      evening: "2:00 - 4:00 PM",
    },
    {
      act: "Village Immersion Walk",
      dur: "1.5-2 hrs",
      morning: "—",
      evening: "3:00 - 5:00 PM",
    },
  ],

  summer: [
    {
      act: "Birding",
      dur: "2 hrs",
      morning: "6:00 - 8:00 AM",
      evening: "5:00 - 7:00 PM",
    },
    {
      act: "Wildlife Safari",
      dur: "3 hrs",
      morning: "6:00 - 9:00 AM",
      evening: "2:30 - 5:30 PM",
    },
    {
      act: "Cycling (Mountain / Riverside)",
      dur: "1-2 hrs",
      morning: "7:00 - 9:00 AM",
      evening: "5:00 - 7:00 PM",
    },
    {
      act: "Guided Jungle Walk",
      dur: "2-3 hrs",
      morning: "06:00 - 08:00 AM",
      evening: "03:00 - 05:00 PM",
    },
    {
      act: "Body Surfing (River Session)",
      dur: "1-2 hrs",
      morning: "9:00 - 11:00 AM",
      evening: "3:00 - 5:00 PM",
    },
    {
      act: "Village Immersion Walk",
      dur: "1.5-2 hrs",
      morning: "—",
      evening: "5:00 - 7:00 PM",
    },
  ],
};
  return (
    <>
      <div className="experience-page">
        {/* 1. HERO SECTION */}
        <section className="experience-hero banner_sec">
          <div className="container">
            <div className="d-flex justify-content-center align-items-center">
              <div className="banner-wraper">
                <h1 className="banner-heading">Live the <span>Forest</span></h1>
                <p className="banner-sub-heading">Immersive nature experiences near Corbett National Park.</p>
                <p className="content text-white">At Camp Hornbill, experiences are shaped by the rhythms of the forest and not fixed itineraries. Explore birdwatching in one of India’s richest habitats, walk through jungle trails with local guides, cycle along riverside paths, or immerse yourself in village life. Each experience invites you to slow down, observe closely, and engage deeply with the landscape around you.</p>
              </div>
            </div>
          </div>
        </section>

        {/* 2. SLIDER SECTION */}
        <section className="section-padding">
          <div className="container">
            {/* <div className='slider-mb-30'>
              <div className="nav-container">
                <button className="swiper-nav-btn custom-prev">
                  <img loading="lazy" decoding="async" src={prevSvg} alt="Prev" className='w-100' />
                </button>
                <button className="swiper-nav-btn custom-next">
                  <img loading="lazy" decoding="async" src={nextSvg} alt="Next" className='w-100' />
                </button>
              </div>

              <Swiper
                modules={[Navigation]}
                spaceBetween={30}
                slidesPerView={1}
                navigation={{ nextEl: '.custom-next', prevEl: '.custom-prev' }}
                breakpoints={{ 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
              >
                {activities.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="exp-card">
                      <img loading="lazy" decoding="async" src={item.img} alt="" className="exp-img" />
                      <div className="exp-info-box">
                        <img loading="lazy" decoding="async" src={item.icon} alt="" />
                        <h5 className="sub-heading">{item.title}</h5>
                        <p className="content">{item.desc}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div> */}
            <div className='row g-2 mb-30'>
              {activities.map((item) => (
                <div className='col-xxl-3 col-xl-4'>
                  <div className="exp-card" key={item.id}>
                    <img loading="lazy" decoding="async" src={item.img} alt="" className="exp-img" />
                    <div className="exp-info-box">
                      {/* <img loading="lazy" decoding="async" src={item.icon} alt="" /> */}
                      <h5 className="sub-heading">{item.title}</h5>
                      <p className="content">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center">
              <button className="primary_btn me-3" onClick={openBooking}>Plan Your Activities</button>
              {/* <button className="outline_btn">Explore All Experience</button> */}
            </div>
          </div>
        </section>

        {/* 3. TIMETABLE SECTION */}
        <section className="section-padding bg-color">
          <div className="container">
            <div className='heading-content-wraper'>
              <h2 className="heading text-center">Activity <span>Timetable</span></h2>
              <div className='diveder-bx'></div>
              <p className="content text-center">Plan your day according to the seasons.</p>
            </div>
            <div className='d-flex justify-content-center'>
              <div className="timetable-toggle mb-5">
                <button
                  className={`toggle-btn ${season === 'winter' ? 'active' : ''}`}
                  onClick={() => setSeason('winter')}
                >Winter (Oct – Mar)</button>
                <button
                  className={`toggle-btn ${season === 'summer' ? 'active' : ''}`}
                  onClick={() => setSeason('summer')}
                >Summer (Apr – Sept)</button>
              </div>
            </div>
            <div className="table-responsive custom-table">
              <table className="table m-0">
                <thead>
                  <tr>
                    <th>Activity</th>
                    <th>Duration</th>
                    <th>Morning Slot</th>
                    <th>Afternoon/Evening</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData[season].map((row, i) => (
                    <tr key={i} className="border-bottom">
                      <td className="fw-bold text-start ps-4">{row.act}</td>
                      <td>{row.dur}</td>
                      <td>{row.morning}</td>
                      <td>{row.evening}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default Experience